import { render, staticRenderFns } from "./workLeaveFiles.vue?vue&type=template&id=24a37031&"
import script from "./workLeaveFiles.vue?vue&type=script&lang=js&"
export * from "./workLeaveFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports